import i18n from '../locales/index'
import Vue from 'vue'
import dayjs from 'dayjs'

Vue.directive('time_format', {
  bind: function (el, binding) {
    el.innerHTML = dayjs(binding.value).format('YYYY-MM-DD')
  }
})

Vue.directive('time_format2', {
  bind: function (el, binding) {
    el.innerHTML = dayjs(binding.value).format('YYYY-MM')
  }
})

Vue.directive('time_format3', {
  bind: function (el, binding) {
    el.innerHTML = dayjs(binding.value).format('YYYY-MM-DD HH:mm:ss')
  }
})

Vue.directive('boolean_chinese', {
  bind: function (el, binding) {
    el.innerHTML = binding.value === true ? '是' : i18n.t('directives_index_41')
  }
})

Vue.directive('role_chinese', {
  bind: function (el, binding) {
    switch (binding.value) {
      case 'admin':
        el.innerHTML = i18n.t('directives_index_42')
        break
      case 'editor':
        el.innerHTML = i18n.t('directives_index_43')
        break
      default:
        el.innerHTML = i18n.t('directives_index_44')
    }
  }
})

Vue.directive('machine_status_chinese', {
  bind: function (el, binding) {
    if (binding.value) {
      el.innerHTML = i18n.t('directives_index_45')
    } else {
      el.innerHTML = i18n.t('directives_index_46')
    }
  }
})

Vue.directive('electric_record_status_chinese', {
  bind: function (el, binding) {
    switch (binding.value) {
      case 'started':
        el.innerHTML = i18n.t('directives_index_45')
        break
      case 'stopped':
        el.innerHTML = i18n.t('directives_index_47')
        break
      case 'unlocked':
        el.innerHTML = i18n.t('directives_index_48')
        break
      default:
        el.innerHTML = i18n.t('directives_index_44')
    }
  }
})
